import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Layout from '../components/Layout.vue'
import AdminUser from '../components/AdminUser.vue'
import Partner from '../components/Partner.vue'
import Stock from '../components/Stock.vue'
import Gateway from '../components/Gateway.vue'
import Trigger from '../components/Trigger.vue'
import FaultReport from '../components/FaultReport.vue'
import Device from '../components/Device.vue'
import Shipping from '../components/Shipping.vue'
import Production from '../components/Production.vue'
import Quotation from '../components/Quotation.vue'
import AlarmWatch from '../components/AlarmWatch.vue'
import AIModel from '../components/AIModel.vue'
import AIModelDetail from '../components/AIModelDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    meta: {
      authRequired: true
    },
    children: [
      {
        path: 'admin-user',
        name: 'admin',
        component: AdminUser,
      },
      {
        path: 'partner',
        name: 'partner',
        component: Partner,
      },
      {
        path: 'gateway',
        name: 'gateway',
        component: Gateway,

      },
      {
        path: 'trigger',
        name: 'trigger',
        component: Trigger,

      },
      {
        path: 'device',
        name: 'device',
        component: Device,

      },
      {
        path: 'quotation',
        name: 'quotation',
        component: Quotation,

      },
      {
        path: 'shipping',
        name: 'shipping',
        component: Shipping,

      },
      {
        path: 'production',
        name: 'production',
        component: Production,

      },
      {
        path: 'stock',
        name: 'stock',
        component: Stock,

      },
      {
        path: 'AlarmWatch',
        name: 'alarmWatch',
        component: AlarmWatch,

      },
      {
        path: 'FaultReport',
        name: 'faultReport',
        component: FaultReport,

      },
      {
        path:'ai-model',
        name:'aimodel',
        component:AIModel
      },
      {
        path:'ai-model/:modelId',
        name:'aimodelDetail',
        component:AIModelDetail
      },
      { path: '', redirect: '/partner' }
    ]
  },

  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  { path: '*', redirect: '/partner' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  let adminUser = localStorage.getItem('adminUser');
  if (authRequired && !adminUser) {
    return next('/login');
  }
  adminUser = JSON.parse(adminUser)
  return next();
})


export default router
